<!-- eslint-disable max-len -->
<template>
  <div>
    <!-- Layer Access Application -->
    <div class="card-layer">
      <div
        class="d-flex justify-content-between align-items-center"
        style="padding-right: 38px;"
      >
        <div class="d-flex align-items-center">
          <h4 class="mb-0 mr-2">Layer Access Application</h4>
          <jTooltipHint description="Access the page using password" />
        </div>
        <j-toggle
          v-model="setupApplication.is_use_password"
          style="height: 20px;"
        />
      </div>

      <div v-if="setupApplication.is_use_password">
        <div class="information">
          <img src="@/assets/icon/info.svg" >
          <div>
            <p>Information</p>
            <span>If you implement security on layer access application, users will be required to enter their own password before accessing the application.</span>
          </div>
        </div>

        <!-- Session Access -->
        <b-row class="session-access">
          <b-col cols="12">
            <b-form-group>
              <div
                class="d-flex align-items-center"
                style="margin-bottom: 5px;"
              >
                <label class="mb-0 mr-2"> Standby Session Access </label>
                <jTooltipHint description="Session or duration for tolerance no one accesses the application, after that the user must request OTP re-verification" />
              </div>
              <j-single-select
                v-model="setupApplication.standby_session"
                :error-required="false"
                :options="standbySessionAccess"
                placeholder="Select..."/>
            </b-form-group>
          </b-col>
        </b-row>

        <div>
          <b-button
            class="btn blue mt-3"
            @click="submitApplication">
            Save
          </b-button>
        </div>
      </div>
    </div>

    <!-- Layer Access Pages -->
    <div class="card-layer">
      <div
        class="d-flex justify-content-between align-items-center"
        style="padding-right: 38px;"
      >
        <div class="d-flex align-items-center">
          <h4 class="mb-0 mr-2">Layer Access Pages</h4>
          <jTooltipHint description="Access the page using password" />
        </div>
        <j-toggle
          v-model="useSecurityPage"
          style="height: 20px;"
        />
      </div>

      <div v-if="useSecurityPage">
        <!-- Pages List -->
        <div class="mt-3">
          <jPagesList
            :list-pages="listPages"
            @open-setting="openModalSecurityPage"
          />
        </div>
      </div>
    </div>

    <!-- Popup Setting Security Page -->
    <b-modal
      ref="modalSecurityPage"
      class="mod-form modal-security-pages"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <div>
        <jPopupSecurityPage
          v-if="isOpenPopup"
          :list-function="listFunction"
          :selected-pages="selectedPages"
          @close-modal="closeModalEditField"
        />
      </div>
    </b-modal>

    <j-progress
      ref="progressMappingPage"
      :data-kirim="data_selected"
      :url-api="url_mapping_page"
      :headers="headers"
      @finish="finishActionPage"/>
  </div>
</template>

<script>
/* eslint-disable max-len, func-names, no-param-reassign, consistent-return, array-callback-return */
import { mapActions } from 'vuex';
import jPagesList from '@/views/access/components/jPagesList';
import jProgress from '@/components/progress-screen/jProgress';
import jPopupSecurityPage from '@/views/access/components/jPopupSecurityPage';
import jwtDecode from 'jwt-decode';
import jTooltipHint from '@/components/tooltip/jTooltipHint';
import Vue from 'vue';

export default {
  components: {
    jPagesList,
    jPopupSecurityPage,
    jTooltipHint,
    jProgress,
  },

  data() {
    return {
      applicationId: '',
      isOpenPopup: false,
      standbySessionAccess: [
        { id: '1 Minutes', text: '1 Minutes' },
        { id: '5 Minutes', text: '5 Minutes' },
        { id: '10 Minutes', text: '10 Minutes' },
        { id: '15 Minutes', text: '15 Minutes' },
      ],
      setupApplication: {
        application_id: Number(this.$route.params.id),
        is_use_password: false,
        standby_session: '5 Minutes',
      },
      useSecurityPage: false,
      selectedPages: null,
      listFunction: [],
      listPages: [],
      data_selected: [],
      url_mapping_page: '/nocode/dynamic-apps/security-page/set',
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
    };
  },

  computed: {
    headers() {
      const token = Vue.ls.get('Token');
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      return headers;
    },
  },

  watch: {
    useSecurityPage(val) {
      if (!val) {
        this.alertToggle('all pages');
      }
    },
    'setupApplication.is_use_password': function (val) {
      if (!val) {
        this.disableApplication();
      } else {
        this.setupApplication.standby_session = '5 Minutes';
      }
    },
  },

  async created() {
    this.applicationId = this.$route.params.id;

    this.getApplicationDetail();
    this.getSecurityApplication();
    this.getListFunction();
  },


  methods: {
    ...mapActions('jStoreSecurityPage', ['actionGetSecurityApp', 'actionGetSecurityPages', 'actionSetSecurityApp', 'actionSetSecurityPages']),
    ...mapActions('jStoreNotificationScreen', ['showLoading', 'hideLoading']),
    ...mapActions('jStoreSetting', ['actionGetPagesList']),
    ...mapActions('jStoreAutomation', ['getDetailAutomation']),

    getApplicationDetail() {
      const applicationId = this.applicationId;
      const param = {
        params: {
          page: 1,
          limit: 0,
          column: 'id',
          sort: 'asc',
          query: '',
          query_type: '',
        },
      };
      this.actionGetPagesList({ applicationId, param }).then((res) => {
        if (!res.error) {
          this.listPages = res.data;
          this.getSecurityPages();
        }
      });
    },

    getSecurityApplication() {
      this.actionGetSecurityApp(this.applicationId).then((res) => {
        this.setSecurityApplication(res.data);
      });
    },

    getSecurityPages() {
      const data = {
        applicationId: this.applicationId,
      };

      this.actionGetSecurityPages(data).then((res) => {
        if (!res.error) {
          this.setSecurityPages(res.data);
        }
      });
    },

    getListFunction() {
      const dataFilter = {
        company_id: this.session.user.company_id,
      };
      dataFilter['trigger.type'] = 'function';
      const param = {
        limit: 1000000,
        page: 1,
        sort: { created_at: -1 },
        filter: JSON.stringify(dataFilter),
      };
      this.getDetailAutomation(param).then((res) => {
        this.listFunction = res.data.data.map(e => ({
          id: e.trigger.function ? e.trigger.function.name : '',
          name: e.trigger.function ? e.trigger.function.name : '',
        }));
      });
    },

    setSecurityApplication(data) {
      if (data) {
        // Set security application data
        this.setupApplication = {
          application_id: data.application_id,
          is_use_password: data.is_use_password,
          standby_session: data.standby_session,
        };
      }
    },

    setSecurityPages(datas) {
      if (datas.length > 0) {
        const arrSecurity = [];

        this.listPages.map((page) => {
          datas.forEach((data) => {
            if (page.id === data.page_id) {
              page.application_id = data.application_id;
              page.page_id = data.page_id;
              page.security_type = data.security_type;
              page.otp_method = data.otp_method;
              page.function_name = data.function_name;
              page.otp_session = data.otp_session;
              page.standby_session = data.standby_session;

              arrSecurity.push(!!data.security_type);
              return page;
            }
          });
        });

        // Check if have security config
        const isHaveSecurity = arrSecurity.indexOf(true) > -1;
        this.useSecurityPage = isHaveSecurity;
      }
    },

    openModalSecurityPage(data) {
      this.selectedPages = data;
      this.isOpenPopup = true;
      this.$refs.modalSecurityPage.show();
    },

    closeModalEditField() {
      this.selectedPages = null;
      this.$refs.modalSecurityPage.hide();
      this.isOpenPopup = false;
    },

    submitApplication() {
      this.actionSetSecurityApp(this.setupApplication).then((res) => {
        if (!res.error) {
          this.setSecurityApplication(res.data);
        }
      });
    },

    disableApplication() {
      this.setupApplication.is_use_password = false;
      this.setupApplication.standby_session = '';
      this.alertToggle('application');
    },

    disableAllPages() {
      this.showLoading();
      this.data_selected = [];
      this.listPages.forEach((data, index) => {
        if (data.type === 'visible') {
          this.data_selected.push(
            {
              application_id: data.application_id,
              page_id: data.page_id || Number(data.id),
              security_type: '',
              standby_session: '',
              function_name: '',
              otp_session: '',
              otp_method: '',
              action: 'create',
            },
          );
        }
        if ((index + 1) === this.listPages.length) {
          setTimeout(() => {
            this.hideLoading();
            this.$refs.progressMappingPage.toggleIsVisible();
          }, 1500);
        }
      });
    },

    alertToggle(status) {
      this.$swal({
        title: 'Update Record Pages',
        text: `Are you sure want to disable security ${status}?`,
        showCancelButton: true,
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.value) {
          if (status === 'application') {
            this.submitApplication();
          } else {
            this.disableAllPages();
          }
        } else {
          this.useSecurityPage = !this.useSecurityPage;
        }
      });
    },

    finishActionPage() {
      this.getSecurityPages();
    },
  },
};
</script>

<style lang="scss" scoped>
  .card-layer {
    min-width: 524px;
    max-width: 60%;
    background-color: white;
    border: 1px solid #E7E7E7;
    border-radius: 14px;
    padding: 16px;
    margin-bottom: 20px;

    h4 {
      font-family: 'Poppins-Regular';
      font-size: 14px;
      font-weight: 700;
      letter-spacing: 0.02em;
      color:#8A8A8A;
    }
  }
  .information {
    width: 100%;
    background-color: #F5FAFF;
    border-radius: 8px;
    padding: 16px 10px;
    margin: 10px 0;
    display: flex;
    align-items: flex-start;

    img {
      width: 14px;
      height: 14px;
      margin-right: 5px;
    }
    p {
      font-family: 'Poppins-Medium';
      font-size: 14px;
      color: #696014;
      margin-bottom: 5px;
    }
    span {
      font-family: 'Poppins-Regular';
      font-size: 12px;
      color: #696014;
    }
  }

  .session-access {
    margin-top: 14px;

    label {
      font-family: 'Poppins-Medium';
      font-size: 12px;
      color: #808285;
      letter-spacing: 0.02em;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/access/tab/jAccessApplicationTabSecurity.vue